import React from 'react'
import styled from 'styled-components';
import { Link } from 'react-scroll';

const Wrapper = styled.div`
  position: fixed;
  z-index: 4;
  top: 0;
  right:${({ sideOpen }) => sideOpen ? 0 : '-200px'};
  padding: 20px;
  padding-top: 80px;
  height: 100%;
  width:200px;
  background: rgba(0,0,0,.9);
  box-sizing: border-box;
  transition: right ease-in 0.3s;
  border-left:1px solid #e9e9e91a;
`
const MenuLink = styled.div`
  color: #fff;
  display: block;
  margin-bottom: 15px;
  font-size: 1.7em;
  
  :hover{
    text-decoration:underline;
  }

`

const menus = [{
  title: "소개",
  to: "hero"
}, {
  title: "혜택",
  to: "benefit0"
}, {
  title: "요금",
  to: "pricing"
}, {
  title: "다운로드",
  to: "download"
}];

function SideMenu({ sideOpen }) {

  return (

    <Wrapper sideOpen={sideOpen}>
      {
        menus.map(menu => (
          <MenuLink key={menu.title}>
            <Link
              spy={true}
              smooth={true}
              to={menu.to}>
              {menu.title}

            </Link>
          </MenuLink>
        ))
      }

    </Wrapper>

  );
}

export default SideMenu;